import { CityBreakTickets } from 'components/common/CityBreak/components/CityBreakBox/components/CityBreakTickets'
import Loader from 'components/shared/Loader'
import { CityBreakTicketsInStateProps } from './CityBreakTicketsInState.types'
import { useIntl } from 'react-intl'
import useCityBreak from 'components/common/CityBreak/utils/useCityBreak'
import { useCityCart } from 'components/common/CityBreak/utils/useCityCart'
import { useEffect } from 'react'

export const CityBreakTicketsInState = ({
    onCtaSuccess,
}: CityBreakTicketsInStateProps) => {
    const { formatMessage } = useIntl()
    const { ticketsOffer: ticketsData, datesRange, daysNumber } = useCityBreak()
    const { cartItems, deleteItemsFromCart, isDeleteLoading, isDeleteSuccess } =
        useCityCart()

    const handleDelete = () => {
        // in accommodation creator, on accommodation step:
        // - remove items from cart if deleting promo while modyfying accommodation
        // - initially simulate adding promo to cart (it is later added to cart along with accommodation)
        if (cartItems.length > 0) deleteItemsFromCart()
        else onCtaSuccess && onCtaSuccess()
    }

    useEffect(() => {
        if (isDeleteSuccess && onCtaSuccess) onCtaSuccess()
    }, [isDeleteSuccess])

    return ticketsData.length === 0 ? (
        <Loader />
    ) : (
        <CityBreakTickets
            title={formatMessage({
                id: 'promo.city_break.tickets_in_cart',
                defaultMessage: '_',
            })}
            datesRange={datesRange}
            tickets={ticketsData}
            daysNumber={daysNumber}
            onDelete={handleDelete}
            isCtaLoading={isDeleteLoading}
            hasPromoTickets
        />
    )
}
